/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneLoginStartRequest
 */
export interface PhoneLoginStartRequest {
    /**
     * 
     */
    phone: string;
}

/**
 * Check if a given object implements the PhoneLoginStartRequest interface.
 */
export function instanceOfPhoneLoginStartRequest(value: object): value is PhoneLoginStartRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function PhoneLoginStartRequestFromJSON(json: any): PhoneLoginStartRequest {
    return PhoneLoginStartRequestFromJSONTyped(json, false);
}

export function PhoneLoginStartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneLoginStartRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
    };
}

export function PhoneLoginStartRequestToJSON(json: any): PhoneLoginStartRequest {
    return PhoneLoginStartRequestToJSONTyped(json, false);
}

export function PhoneLoginStartRequestToJSONTyped(value?: PhoneLoginStartRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
    };
}

